import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipFormsModule } from './controllers/MembershipFormsController';
import { MembershipFormsCreateView } from './create/create';
import { MembershipLifecycleActionFormListDataResolver } from '@b2b/common/resolvers';

export const MembershipFormsView = angular
  .module('acme.view.application.membership.forms', [
    uiRouter,
    'ui.bootstrap',
    MembershipFormsCreateView,
    MembershipFormsModule
  ])
  .config(function config($stateProvider) {
    const membershipForms = {
      name: 'application.membership.forms',
      url: '/:action/forms',
      views: {
        'subview-main@application': {
          controller: 'MembershipFormsController',
          controllerAs: '$ctrl',
          templateUrl: 'views/application/views/membership/forms/forms.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Forms',
        /** Secure With Permissions **/
        // permissions: ['MEMBERSHIP_RULES_VIEW'],
      },
      resolve: {
        MembershipLifecycleActionFormListData: MembershipLifecycleActionFormListDataResolver()
      },
    };

    $stateProvider.state(membershipForms);
  }).name;
